import React from 'react'
import { CompanyCellContainer } from './styled'

const CompanyCell = (props) => {
  const { title, value, selected, disable, onClick } = props
  return (
    <CompanyCellContainer className={disable ? 'disable' : selected ? 'selected' : ''} onClick={() => onClick(value)}>
      <input type='checkbox' disabled={disable} checked={selected} value={value} />
      {title}
    </CompanyCellContainer>
  )
}

CompanyCell.defaultProps = {
  title: '',
  selected: false,
  disable: false
}

export default CompanyCell